import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Zap } from "lucide-react";

export function SiteNav() {
  return (
    <nav className="sticky top-0 z-50 w-full border-b border-white/10 bg-black/50 backdrop-blur-xl" data-testid="site-nav">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <Link href="/" className="flex items-center gap-2 group">
          <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center transition-transform group-hover:scale-105">
            <Zap size={18} className="text-white" fill="white" />
          </div>
          <div className="flex items-baseline gap-0.5">
            <span className="text-lg font-display font-black tracking-tight text-white">Drpr</span>
            <span className="text-lg font-display font-black tracking-tight text-blue-400">.ai</span>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link href="/blog" className="text-sm font-medium text-white/70 hover:text-white transition-colors" data-testid="link-blog">Blog</Link>
          <Link href="/#pricing" className="text-sm font-medium text-white/70 hover:text-white transition-colors" data-testid="link-pricing">Pricing</Link>
          <Link href="/status" className="text-sm font-medium text-white/70 hover:text-white transition-colors" data-testid="link-status">Status</Link>
        </div>

        <div className="flex items-center gap-4">
          <Link href="/signup">
            <Button variant="ghost" className="text-white/70 hover:text-white hover:bg-white/10" data-testid="button-signin">
              Sign In
            </Button>
          </Link>
          <Link href="/signup">
            <Button className="bg-blue-600 hover:bg-blue-500 text-white border-0 shadow-lg shadow-blue-600/20" data-testid="button-get-started">
              Get Started
            </Button>
          </Link>
        </div>
      </div>
    </nav>
  );
}
